import { createTheme } from '@mui/material/styles';
import { type LinkProps } from '@mui/material/Link';
import { LinkBehavior } from '@shared/components/LinkBehaviour';
import { csCZ } from '@mui/x-date-pickers/locales';

const AppTheme = createTheme(
  {
    components: {
      MuiAlert: {
        styleOverrides: {
          standardInfo: {
            color: '#3d3d3d',
            backgroundColor: '#3b83f627',
            '& .MuiAlert-icon': { color: '#3b82f6' },
          },
          outlinedInfo: {
            color: '#3b82f6',
            borderColor: '#3b82f6',
            '& .MuiAlert-icon': { color: '#3b82f6' },
          },
          filledInfo: {
            color: '#FFFFFF',
            backgroundColor: '#3b83f61d',
            '& .MuiAlert-icon': { color: 'inherit' },
          },
        },
      },
      MuiLink: {
        defaultProps: {
          component: LinkBehavior,
        } as LinkProps,
      },

      MuiButton: {
        styleOverrides: {
          root: {
            boxShadow: '0px 2px 6px rgba(0,0,0,0.2)',
            borderRadius: '10px',
            color: '#D02964',
            textTransform: 'none',
            '&:hover': {
              backgroundColor: '#D02964',
              color: '#ffffff',
              '& .MuiButton-startIcon, & .MuiButton-endIcon': {
                '& .MuiSvgIcon-root, & svg': {
                  color: '#ffffff',
                },
              },
            },
            '& .MuiButton-startIcon, & .MuiButton-endIcon': {
              '& .MuiSvgIcon-root, & svg': {
                color: 'inherit',
              },
            },
          },

          contained: {
            color: '#fff',
            boxShadow: '0px 2px 6px rgba(0,0,0,0.2)',
            '&:hover': {
              background: '#D02964',
              color: '#ffffff',
              '& .MuiButton-startIcon, & .MuiButton-endIcon': {
                '& .MuiSvgIcon-root, & svg': {
                  color: '#ffffff',
                },
              },
            },
            '& .MuiButton-startIcon, & .MuiButton-endIcon': {
              '& .MuiSvgIcon-root, & svg': {
                color: '#ffffff',
              },
            },
          },
        },
      },
      MuiSwitch: {
        styleOverrides: {
          root: {},
          thumb: {
            color: '#e33f5c',
          },
          track: {
            backgroundColor: '#e33f5c',
          },
          switchBase: {
            '&.Mui-checked + .MuiSwitch-track': {
              backgroundColor: '#42d029',
            },
            '&.Mui-checked .MuiSwitch-thumb': {
              color: '#42d029',
            },
          },
        },
      },
    },
    typography: {
      fontFamily: 'Roboto, sans-serif',
      h4: {
        fontSize: '2rem',
        fontWeight: 500,
      },
      body1: {
        fontSize: '1rem',
        lineHeight: 1.5,
      },
      caption: {
        fontSize: '0.75rem',
        color: '#797979',
      },
      h6: {
        fontSize: '0.8rem',
        fontWeight: 600,
      },
    },

    palette: {
      success: {
        main: '#42D029',
        light: '#e5ffe0',
      },
      info: { main: '#2993D0', light: '#2993D020', dark: '#2993D0CC' },
      error: { main: '#D02929' },
      warning: { main: '#D0B729', light: '#fdedb6ff' },
      mode: 'light',
      primary: {
        main: '#D02964',
        light: '#D0296420',
        dark: '#D02964CC',
      },
      secondary: {
        main: '#E33F5C',
        light: '#e33f5d3c',
        dark: '#E33F5CCC',
      },
      text: {
        primary: '#132847',
        secondary: '#797979',
        disabled: '#79797940',
      },
      grey: {
        200: '#B0BEC520',
        500: '#B0BEC5CC',
      },
    },
  },
  csCZ,
);

export default AppTheme;
